/**
 * As iniciais do monograma: as duas primeiras palavras que não são ligação.
 * "ESCRITÓRIO EXEMPLO ADVOGADOS" → "EE"; "DA SILVA LTDA" → "SL".
 *
 * ⭐ Saiu da ficha do cliente em 14/09/2026, quando a lista de Clientes passou
 * a desenhar o mesmo monograma: duas contas de iniciais dariam ao mesmo
 * cliente letras diferentes em duas telas.
 */
const LIGACAO = new Set(['DE', 'DA', 'DO', 'DAS', 'DOS', 'E', 'A', 'O', '&']);

export function iniciais(nome: string): string {
  const palavras = nome
    .toUpperCase()
    .split(/\s+/)
    .filter((p) => p && !LIGACAO.has(p));
  return palavras.slice(0, 2).map((p) => p.charAt(0)).join('') || '·';
}
